import SplunkOtelWeb from '@splunk/otel-web'

export function initOpenTelemetry() {
  SplunkOtelWeb.init({
    realm: 'eu0',
    rumAccessToken: 'gFfD4ku_UwRc8PU29Wb2Wg',
    applicationName: 'tmmcore-frontend',
    version: window.rel,
    deploymentEnvironment: window.env,
  })
}
